exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".table thead th[data-v-2ec09064]:first-child{width:100px}", "", {"version":3,"sources":["/home/circleci/phdva/ui/src/views/admin/earning-framework/List.vue"],"names":[],"mappings":"AACA,6CACE,WAAa,CACd","file":"List.vue","sourcesContent":["\n.table thead th[data-v-2ec09064]:nth-child(1){\n  width: 100px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2ec09064","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/views/admin/earning-framework/List.vue
// module id = 2631
// module chunks = 0